import { Card, CardContent } from "js/components/ui/card";
import { Skeleton } from "js/components/ui/skeleton";
import { useIsDesktop } from "hooks/useMediaQuery";

function ReportDetailSkeleton() {
  const isDesktop = useIsDesktop();

  return (
    <div className="space-y-6">
      {/* Highlights panel skeleton */}
      <Card className="gap-0">
        <CardContent className="space-y-4">
          <div className="flex items-start justify-between">
            <div className="space-y-2">
              <Skeleton className="h-6 w-64" />
              <Skeleton className="h-5 w-28" />
            </div>
            <Skeleton className="h-8 w-24" />
          </div>
          <div className="flex gap-6">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-32" />
          </div>
          <Skeleton className="h-8 w-full" />
        </CardContent>
      </Card>

      {/* Two-column skeleton */}
      <div className={isDesktop ? "flex gap-6" : "space-y-6"}>
        {/* Main content */}
        <div className="flex-1 space-y-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Card key={i} className="gap-0">
              <CardContent className="space-y-3">
                <Skeleton className="h-5 w-48" />
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-4 w-32" />
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Sidebar */}
        <div className={isDesktop ? "w-80 space-y-4" : "space-y-4"}>
          {Array.from({ length: 2 }).map((_, i) => (
            <Card key={i} className="gap-0">
              <CardContent className="space-y-3">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

export { ReportDetailSkeleton };
